import Swiper from 'swiper';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
const breakpoint = window.matchMedia('(min-width: 992px)');
let mySwiper;

const breakpointChecker = function () {
    if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
    } else if (breakpoint.matches === false) {
        return enableSwiper();
    }
};

const enableSwiper = function () {
    mySwiper = new Swiper('.info-blocks', {
        loop: true,
        slideToClickedSlide: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        loopedSlides: 10,
        updateOnWindowResize: true,
        on: {
            afterInit: function (swiper) {
                let current_slide = swiper.slides[swiper.activeIndex];
                $('.info-blocks .box .text-wrap .short').slideDown(100);
                $('.info-blocks .box .text-wrap .long').slideUp(100);
                $(current_slide).find('.box .text-wrap .short').slideUp(100);
                $(current_slide).find('.box .text-wrap .long').slideDown(500);
            },
            slideChange: function (swiper) {
                let current_slide = swiper.slides[swiper.activeIndex];
                $('.info-blocks .box .text-wrap .short').slideDown(100);
                $('.info-blocks .box .text-wrap .long').slideUp(100);
                $(current_slide).find('.box .text-wrap .short').slideUp(100);
                $(current_slide).find('.box .text-wrap .long').slideDown(500);
            },
        }
    });
};

breakpoint.addListener(breakpointChecker);

breakpointChecker();

$(window).resize(function () {
    $('.section-info-blocks .info-blocks .box, .section-info-blocks .info-blocks .item').removeClass('-active');
});

$('.section-info-blocks .info-blocks .box, .section-info-blocks .info-blocks .box-back').on('click', function () {
    $(this).closest('.item').toggleClass('-active');
});

let section_info_blocks = document.querySelectorAll('.section-info-blocks');
section_info_blocks.forEach((element, index) => {
    gsap.timeline({
        scrollTrigger: {
            trigger: element,
            endTrigger: element,
            scrub: true,
            onToggle: function (self) {
                if (!self.isActive) {
                    let el_item = element.querySelectorAll('.item.-active');

                    if (el_item.length > 0) {
                        el_item.forEach((element, index) => {
                            element.classList.remove('-active');
                        });
                    }
                }
            },
        }
    });
});